import type { EquipmentDataQueryCache, MoveAllInventoryPayload } from '@entities/equipment';

const TOTAL_INFO_FIELD = 'total_info';
const SORT_INDEX_FIELD = 'sort_index';
const INVENTORY_COUNT_FIELD = 'inventory_count';
const TOTAL_INVENTORY_COST_FIELD = 'total_inventory_cost';
const DECOMMISSIONED_INVENTORY_COUNT_FIELD = 'decommissioned_inventory_count';
const DECOMMISSIONED_INVENTORY_COST_FIELD = 'decommissioned_inventory_cost';

export const moveAllInventoryInCache = ({
    previous,
    fromWarehouseId,
    toWarehouseId,
}: MoveAllInventoryPayload & {
    previous: EquipmentDataQueryCache | undefined;
}): EquipmentDataQueryCache | undefined => {
    const equipment = previous?.data.response.equipment;

    if (!previous || !equipment) {
        return previous;
    }

    const fromWarehouse = equipment.find((item) => item.id === fromWarehouseId);
    const toWarehouse = equipment.find((item) => item.id === toWarehouseId);

    if (!fromWarehouse || !toWarehouse || !fromWarehouse.items.length) {
        return previous;
    }

    const movedItems = fromWarehouse.items;
    const nextEquipment = equipment.map((warehouse) => {
        if (warehouse.id === fromWarehouseId) {
            return {
                ...warehouse,
                items: [],
                [TOTAL_INFO_FIELD]: {
                    ...warehouse[TOTAL_INFO_FIELD],
                    [INVENTORY_COUNT_FIELD]: 0,
                    [TOTAL_INVENTORY_COST_FIELD]: 0,
                    [DECOMMISSIONED_INVENTORY_COUNT_FIELD]: 0,
                    [DECOMMISSIONED_INVENTORY_COST_FIELD]: 0,
                },
            };
        }

        if (warehouse.id === toWarehouseId) {
            return {
                ...warehouse,
                items: [...warehouse.items, ...movedItems].map((item, index) => ({
                    ...item,
                    [SORT_INDEX_FIELD]: index,
                })),
                [TOTAL_INFO_FIELD]: {
                    ...warehouse[TOTAL_INFO_FIELD],
                    [INVENTORY_COUNT_FIELD]:
                        warehouse[TOTAL_INFO_FIELD][INVENTORY_COUNT_FIELD] +
                        fromWarehouse[TOTAL_INFO_FIELD][INVENTORY_COUNT_FIELD],
                    [TOTAL_INVENTORY_COST_FIELD]:
                        warehouse[TOTAL_INFO_FIELD][TOTAL_INVENTORY_COST_FIELD] +
                        fromWarehouse[TOTAL_INFO_FIELD][TOTAL_INVENTORY_COST_FIELD],
                    [DECOMMISSIONED_INVENTORY_COUNT_FIELD]:
                        warehouse[TOTAL_INFO_FIELD][DECOMMISSIONED_INVENTORY_COUNT_FIELD] +
                        fromWarehouse[TOTAL_INFO_FIELD][DECOMMISSIONED_INVENTORY_COUNT_FIELD],
                    [DECOMMISSIONED_INVENTORY_COST_FIELD]:
                        warehouse[TOTAL_INFO_FIELD][DECOMMISSIONED_INVENTORY_COST_FIELD] +
                        fromWarehouse[TOTAL_INFO_FIELD][DECOMMISSIONED_INVENTORY_COST_FIELD],
                },
            };
        }

        return warehouse;
    });

    return {
        ...previous,
        data: {
            ...previous.data,
            response: {
                ...previous.data.response,
                equipment: nextEquipment,
            },
        },
    };
};
